// extracted by mini-css-extract-plugin
module.exports = {"mobile":"aD","tablet":"aE","bigTablet":"aF","desktop":"aG","notMobile":"aH","notTablet":"aI","notBigTablet":"aJ","notDesktop":"aK"};